export const dateElementsExtractor = (date) => {
  // dateString: e.g. 2020/01/01
  // const matches = dateString.match(/(\d+)\/(\d+)\/(\d+)/);

  // return {
  //   year: matches[1],
  //   month: matches[2],
  //   day: matches[3],
  // };
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const japaneseDay = ['日', '月', '火', '水', '木', '金', '土'][date.getDay()];

  return { year, month, day, japaneseDay };
};
